<template>
  <div class="insured-edit">
    <a-form-model class="edit-instured-form" ref="editForm" :model="editInsuredForm" :rules="rules">
      <!-- 遍历被保人修改配置数据 -->
      <div v-for="cfg in editItems" :key="cfg.type">
        <!-- 被保人信息部分 -->
        <div class="insture-part">
          <correct-title class="insture-title" :title="cfg.title" />
          <a-row>
            <!-- 循环修改被保人字段 -->
            <template v-for="item in cfg.items">
              <a-col :class="['edit_' + item.key, item.cls]" :span="12" v-if="!item.isHide" :key="item.key"> <form-item :fieldItem="item" :editForm="editInsuredForm" :editIndex="editIndex" :formItemProp="item.isHide ? '' : item.key" :labelCol="labelCol" :wrapperCol="wrapperCol"></form-item> </a-col
            ></template>
          </a-row>
        </div>
      </div>
    </a-form-model>
    <div class="edit-save-box" slot="footer">
      <a-button class="edit-save" @click="save">保存</a-button>
    </div>
  </div>
</template>

<script>
import { insuredMixins } from '@/views/correct/mixins/insuredMixins';
import commonOptions from '../common/options';
import commonMethods from '../common/methods';
import correctTitle from './title';
import formItem from '../components/formItem/index.vue';
export default {
  name: 'insuredEdit',
  mixins: [insuredMixins],
  components: {
    correctTitle,
    formItem
  },
  props: {
    // 操作类型（1：新增；2：修改）
    operateType: {
      type: Number,
      default: 1
    },
    // 修改的被保人数据下标
    editIndex: {
      type: Number,
      default: 0
    },
    // 修改回显的被保人数据
    insuredData: {
      type: Object,
      default: () => {}
    },
    // 被保人新增、修改需要的配置数据
    editCfg: {
      type: Object,
      default: () => {}
    },
    // 保单生效日期
    effectiveDate: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      labelCol: { span: 8 },
      wrapperCol: { span: 14 },
      // 修改被保人表单数据
      editInsuredForm: {
        batchPlanParam: {},
        batchInsuredExt: {}
      }
    };
  },
  computed: {
    // 计算被保人组件配置数据
    editItems() {
      let editItems = [
        {
          // 被保人基础信息部分
          type: 'insured',
          title: '被保人信息',
          items: [
            { label: '批单生效日', key: 'batchDate', type: 'date', disabledDate: this.batchDateDisDate, writeable: true },
            { label: '被保人姓名', key: 'name', writeable: true },
            { label: '手机号', key: 'mobile', writeable: true },
            { label: '证件类型', key: 'idType', type: 'select', writeable: true, dataSource: commonOptions.idTypeOps, changeFn: this.idTypeChange },
            { label: '证件号码', key: 'idNumber', writeable: true, blurFn: this.changeIdNumber },
            { label: '出生日期', key: 'birthDate', type: 'date', disabledDate: this.birthdateDisDate, writeable: true },
            { label: '性别', key: 'gender', type: 'select', writeable: true, dataSource: commonOptions.genderOps }
          ]
        }
      ];
      // 如果传递的配置存在，则用传递的配置
      if (this.editCfg) {
        if (this.operateType === 2 && this.editCfg.editItems && this.editCfg.editItems.length) {
          editItems = this.filterItems(this.editCfg.editItems);
        } else if (this.operateType === 1 && this.editCfg.addItems && this.editCfg.addItems.length) {
          editItems = this.filterItems(this.editCfg.addItems);
        }
      }
      return editItems;
    },
    // 修改被保人弹窗表单规则数据
    rules() {
      let rules = {
        batchDate: [{ required: true, message: '请选择批单生效日', trigger: 'change' }],
        name: [{ required: true, message: '请输入被保人姓名', trigger: 'blur' }],
        mobile: [{ required: false, message: '请输入正确的手机号', trigger: 'blur' }],
        idType: [{ required: true, message: '请选择证件类型', trigger: 'change' }],
        idNumber: [{ required: true, message: '请输入证件号码', trigger: 'blur' }],
        birthDate: [{ required: true, message: '请选择出生日期', trigger: 'change' }],
        gender: [{ required: true, message: '请选择性别', trigger: 'change' }]
      };
      // 如果传递的配置存在，则用传递的配置
      if (this.editCfg) {
        if (this.operateType === 1 && this.editCfg.addRules) {
          rules = this.editCfg.addRules;
        } else if (this.operateType === 2 && this.editCfg.editRules) {
          rules = this.editCfg.editRules;
        }
      }
      return rules;
    }
  },
  created() {
    if (this.insuredData) {
      this.editInsuredForm = this.$lodash.cloneDeep(this.insuredData);
    }
  },
  methods: {
    // 根据设备类型过滤被保人配置
    filterItems(list) {
      let editItems = [];
      list.forEach(cfg => {
        let arr = [];
        cfg.items.forEach(item => {
          if (!item.deviceType || item.deviceType === 'p') {
            arr.push(item);
          }
        });
        cfg.items = arr;
        editItems.push(cfg);
      });
      return editItems;
    },
    // 编辑保存
    save() {
      this.$refs.editForm.validate(vaild => {
        if (vaild) {
          this.$emit('onSave', this.editInsuredForm, this.editIndex);
        }
      });
    },
    // 证件类型change事件
    idTypeChange() {
      this.$set(this.editInsuredForm, 'idNumber', '');
    },
    // 身份证号码change
    changeIdNumber(value) {
      if (!value) {
        return false;
      }
      const idType = this.editInsuredForm.idType;
      const flag = commonMethods.checkIdNumber(value, idType);
      // 如果证件类型是 1：身份证 && 身份证号码正确
      if (flag && idType == '1') {
        const { birthDate, gender } = commonMethods.calcBGByIdCardNumber(value);
        this.$set(this.editInsuredForm, 'birthDate', birthDate);
        this.$set(this.editInsuredForm, 'gender', gender);
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.insured-edit {
  .edit_batchDate {
    margin-right: 10px;
    &.no_margin {
      margin-right: 0;
    }
  }
  .flex_ {
    display: flex;
    align-items: center;
  }
  .insture-title {
    margin-bottom: 17px;
  }
}
</style>
